export const uploadSubRoute = {
  presignedUrl: "presignedUrl",
} as const;

export interface UploadRoutes {
  sub: typeof uploadSubRoute.presignedUrl;
  method?: "Post";
}
